@if (value) {
  <div [tooltip]="true" [tooltipInvertTextColor]="true">
     <span class="flex items-center">
    <span class="rounded w-2 h-2 block mr-2 flex-shrink-0" [ngClass]="color ?? 'bg-gray-100'"></span>
       {{ (value || '-' ) | translate }}
    </span>
  </div>
} @else {
  <span class="text-slate-300">-</span>
}
